// ** Redux Imports
import { createAsyncThunk , createSlice } from "@reduxjs/toolkit"
// ** Axios Imports
import API from "../../../../utility/custom/API";

export const getData = createAsyncThunk('appQuiz/getData', async params => {
  let response = ''
 if (params.status !== '' && params.q.length > 0) {
    response = await API.get(`items/getAll?page=${params.page}&has_maraton=1
    &keyword=${params.q}&maraton_type=${params.status}`)
    
  } else if (params.q.length > 0) {
    response = await API.get(`items/getAll?page=${params.page}&has_maraton=1&keyword=${params.q}`)
    
  } else if (params.status !== '') {
    response = await API.get(`items/getAll?page=${params.page}&has_maraton=1&maraton_type=${params.status}`)
  } else {
    response = await API.get(`items/getAll?page=${params.page}&has_maraton=1`)
  }
  return {
    data: response.data,
    allData: response.data,
    totalPages: response.total,
    params
    
  }
})

export const getQuizUsers = createAsyncThunk('appQuiz/getQuizUsers', async paramsUsers => {
     const dataInfo = new FormData()
     dataInfo.append("id", paramsUsers.id)
     const response = await API.post(`items/users?page=${paramsUsers.page}
     &checked=${paramsUsers.status === "checked" ? "1" :"0"}`,dataInfo)
     
     const newDataWithId = response.data.map(user => {
          return {
               ...user,_id:paramsUsers.id
          }
     })
     
     return {
          dataUsers: newDataWithId,
          allDataUsers: newDataWithId,
          totalPagesUsers: response.total,
          paramsUsers
     }
})
export const appQuizSlice = createSlice({
  name: 'appQuiz',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
       dataUsers: [],
       totalPagesUsers: 1,
       allDataUsers: [],
       paramsUsers: {},
     
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getData.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.allData = action.payload.allData
      state.total = action.payload.totalPages
      state.params = action.payload.params
    })
           .addCase(getQuizUsers.fulfilled, (state, action) => {
                state.dataUsers = action.payload.dataUsers
                state.allDataUsers = action.payload.allDataUsers
                state.totalPagesUsers = action.payload.totalPagesUsers
                state.paramsUsers = action.payload.paramsUsers
           })
  }
})

export default appQuizSlice.reducer
